import l10n from "../l10n/localization";
import * as utils from "./utils";

export function portToForm(client) {
    let cleanedPort= Object.assign({}, client);
    if (cleanedPort.country !== undefined && cleanedPort.country.id !== undefined) {
        cleanedPort.country = cleanedPort.country.id;
    }
    return cleanedPort;
}

export function portToSelect(ports, add = false) {
    let cleanedPorts = [];

    if(add){
        cleanedPorts.push({
            label: l10n.client.button.add,
            value: 0,
            item: null,
        });
    }


    ports.map((item) => {
        let countryName = utils.notNullNorUndefined(item.countryName) ? ' (' + item.countryName + ')' : '';

        cleanedPorts.push({
            label: item.name + countryName,
            value: item.id,
            item: item,
        });

        return item;
    });

    return cleanedPorts;
}

export function flattenCountry(items) {
    let newItems = [];
    for (let i = 0; i < items.length; i++) {
        let newItem = items[i];
        if (utils.notNullNorUndefined(newItem.country)) {
            newItems.push({...newItem, countryName: newItem.country.name});
        } else {
            newItems.push(newItem);
        }
    }
    return newItems;
}


// WEBPACK FOOTER //
// ./src/utils/port.js